export default __webpack_public_path__ + "static/media/E4wJYAkVcAE6COV.fa206271.jpg";